import { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import Tizen from "../../../../assets/icons/galaxy_store_1.png";
import Wear from "../../../../assets/icons/goggleplay_1.png";
import Timeflik from "../../../../assets/icons/timeflik.png"
import NewTag from "../../../../assets/icons/newTag.png"
import GetFree from "../../../../assets/icons/IconGen/getFreeButton.png"
import NowFree from "../../../../assets/icons/IconGen/nowFreeButton.png"
import SamWatchFree from "../../../../assets/icons/IconGen/samwatchFreeButton.png"
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";
import { newItemTag } from "../../utils/util";
import WatchFrameGray from "../../../../assets/icons/FloatingMenu/watchGrayFrame.png"
import WatchFrameWhite from "../../../../assets/icons/FloatingMenu/watchWhiteFrame.png"
import WatchFrameBlack from "../../../../assets/icons/FloatingMenu/watchBlackFrame.png"
import ClassicFrameGray from "../../../../assets/icons/FloatingMenu/classicGrayFrame.png"
import ClassicFrameBlack from "../../../../assets/icons/FloatingMenu/classicBlackFrame.png"
import Watch8UltraFrame from "../../../../assets/icons/FloatingMenu/watch8UltraFrame.png"
import UltraWhiteFrame from "../../../../assets/icons/FloatingMenu/ultraWhiteFrame.png"
import UltraBlackFrame from "../../../../assets/icons/FloatingMenu/ultraBlackFrame.png"
import UltraOrangeFrame from "../../../../assets/icons/FloatingMenu/ultraOrangeFrame.png"
import Watch8GeneralFrame from "../../../../assets/icons/FloatingMenu/watch8GeneralFrame.png"
import Watch8ClassicFrame from "../../../../assets/icons/FloatingMenu/watch8ClassicFrame.png"
import Watch8ClassicWhiteFrame from "../../../../assets/icons/FloatingMenu/watch8ClassicWhiteFrame.png"
import Watch8GeneralBlackFrame from "../../../../assets/icons/FloatingMenu/watch8GeneralBlackFrame.png"

import Discount from "./Discount";

const CarouselList = ({ data, onclick, selectedType, theme, selectedWatchFrame }: any) => {
  const [images, setImages] = useState([]),
    [os, setOs] = useState<string[]>([""]);

  // 캐로젤 리스트의 이미지 표시 영역
  const handleWatchFrame = () => {
    switch (selectedWatchFrame) {
      case "watch8General": return Watch8GeneralFrame
      case "watchGray": return WatchFrameGray
      case "watchWhite": return WatchFrameWhite
      case "watchBlack": return WatchFrameBlack
      case "watch8Classic": return Watch8ClassicFrame
      case "classicGray": return ClassicFrameGray
      case "classicBlack": return ClassicFrameBlack
      case "watch8Ultra": return Watch8UltraFrame
      case "ultraWhite": return UltraWhiteFrame
      case "ultraOrange": return UltraOrangeFrame
      case "ultraBlack": return UltraBlackFrame
      case "watch8ClassicWhite": return Watch8ClassicWhiteFrame
      case "watch8GeneralBlack": return Watch8GeneralBlackFrame
      default: return Watch8GeneralFrame
    }
  }

  useEffect(() => {
    const arr: any = [];
    if (selectedType === "wear") {
      setOs(["wear"]);
      data?.wear_images?.map((i: any) =>
        arr.push({ url: i.image_url, alt: i?.sku, title: "Wear" })
      );
    } else if (selectedType === "tizen") {
      setOs(["tizen"]);
      data?.tizen_images?.map((i: any) =>
        arr.push({ url: i.image_url, alt: i?.sku, title: "Tizen" })
      );
    } else {
      setOs(data?.os);
      if (data?.wear_images && data?.wear_images.length > 0) {
        data?.wear_images?.map((i: any) =>
          arr.push({ url: i.image_url, alt: i?.sku, title: "Wear" })
        );
      }
      if (data?.theme_images && data?.theme_images.length > 0) {
        data?.theme_images?.map((i: any) =>
          arr.push({ url: i.image_url, alt: i?.sku, title: "Theme" })
        );
      }
    }
    setImages(arr);
  }, [data, selectedType]);

  const selectWearVendorImage = (vendor: string) => {
    switch (vendor) {
      case "timeflik":
        return Timeflik;
      case "google":
        return Wear;

      default: return Wear
    }
  }

  return (
    <div
      className={`${theme ? "themecarousel" : "watchcarousel"
        } relative justify-center flex-shrink-0`}
    >
      {images.length ? (
        <Carousel
          showThumbs={false}
          showStatus={false}
          swipeable={false}
          showIndicators={images?.length < 2 ? false : true}
          renderArrowPrev={(onClickHandler, hasPrev) =>
            hasPrev && (
              <button
                className={`absolute hidden sm:block rounded-full bg-gray-800 opacity-60 z-10 text-white top-[calc(50%-10px)] md:top-[calc(50%-12px)] w-5 md:w-6 left-1 ${theme && "lg:top-[calc(50%-1rem)] lg:w-8 lg:left-2"
                  }`}
                type="button"
                onClick={onClickHandler}
              >
                <ChevronLeftIcon className="-ml-0.5" />
              </button>
            )
          }
          renderArrowNext={(onClickHandler, hasNext) =>
            hasNext && (
              <button
                className={`absolute hidden sm:block rounded-full bg-gray-800 opacity-60 z-10 text-white top-[calc(50%-10px)] md:top-[calc(50%-12px)] w-5 md:w-6 right-1 ${theme && "lg:top-[calc(50%-1rem)] lg:w-8 lg:right-2"
                  }`}
                type="button"
                onClick={onClickHandler}
              >
                <ChevronRightIcon className="-mr-0.5" />
              </button>
            )
          }
        >
          {images?.map((item: any, idx: number) => {
            return (
              <div
                key={idx}
                className="-ml-8 -mt-4 hover:bg-black content-center flex-shrink-0 hover:cursor-pointer"
                onClick={() => {
                  onclick(data);
                }}
              >
                <img
                  style={{ "borderRadius": os?.includes("wear") ? "20%" : "5%", "boxShadow": "0 1px 2px 0 rgba(60,64,67,3), 0 1px 3px 1px rgba(60,64,67,.15)", position: "relative" }}
                  src={item?.url}
                  className={`object-contain w-[calc(33.33vw-1.5rem)] sm:w-[calc(25vw-2.25rem)] md:w-[7.75rem] h-[calc(33.33vw-1.5rem)] sm:h-[calc(25vw-2.25rem)] md:h-[calc(20vw-2rem)] ${theme
                    ? "lg:w-[calc(25vw-3.625rem)] 2xl:w-[calc(21rem-30px)] lg:h-[calc(25vw-3.625rem)] 2xl:h-[calc(21rem-30px)]"
                    : "lg:w-[calc(16.66vw-1.83rem)] xl:w-[calc(14.3vw-2.7rem)] 2xl:w-[calc(10.5rem-15px)] lg:h-[calc(16.66vw-1.83rem)] xl:h-[calc(14.3vw-2.7rem)] 2xl:h-[calc(10.5rem-15px)]"
                    }`}
                  alt={item?.alt}
                />
                {
                  os.includes('wear') ?
                    <div className="watchFrame">
                      <img
                        src={handleWatchFrame()}
                        alt=""
                      />
                      <div className="absolute bottom-[15%] left-[25%] w-full max-w-[415px]: left-[23%] bottom-[8%]">
                        <Discount
                          is_discount={data?.is_discount}
                          discount_rate={data?.discount_rate}
                        />
                      </div>
                    </div>
                    : null
                }

              </div>
            );
          })}
        </Carousel>
      ) : undefined}

      <div
        className={`absolute lg:top-2 sm:top-1 top-0.5 flex flex-row gap-2 ${theme
          ? "right-0.5 sm:right-1 lg:right-2"
          : "left-0.5 sm:left-1 lg:left-2"
          }`}
      >

        <img
          style={{ paddingLeft: ".1rem" }}
          className={`${os?.includes("wear") ? "" : "hidden"} ${data?.vendor === "timeflik"
            ? "h-10 w-10 lg:h-14 lg:w-14 lg:-mt-4 -mt-2 ml-1"
            : "mt-1 h-5 ml-1 sm:h-5 lg:h-7"
            }`}
          src={selectWearVendorImage(data?.vendor)}
          alt=""
        />
        <img
          style={{ "marginTop": ".2rem" }}
          className={`${os?.includes("tizen") ? "" : "hidden"
            } h-5 sm:h-6 lg:h-7`}
          src={Tizen}
          alt=""
        />

      </div>
      {/* <div className="absolute right-0">
        <Discount is_discount={data?.is_discount} discount_rate={data?.discount_rate} />
      </div> */}
      <div
        className={`absolute lg:top-2 sm:top-1 top-0.5 flex flex-row gap-2`}
      >
        <img
          style={{ cursor: "pointer" }}
          onClick={() => onclick(data)}
          src={data.enable_get_coupon ? GetFree :
            data.enable_now_coupon ? NowFree :
              data.enable_free_coupon ? SamWatchFree :
                ""}
          alt=""
        />
      </div>

      <div
        className={`text-white text-center break-words mt-3 text-xs lg:text-sm hover:cursor-default mb-1 w-[calc(33.33vw-1.5rem)] sm:w-[calc(25vw-2.25rem)] md:w-[calc(20vw-2rem)] ${theme
          ? "lg:w-[calc(25vw-3.625rem)] 2xl:w-[calc(21rem-30px)]"
          : "lg:w-[calc(16.66vw-1.83rem)] xl:w-[calc(14.3vw-2.7rem)] 2xl:w-[calc(10.5rem-15px)]"
          }`}
      >
        {newItemTag(data?.created_at) ?
          <div>
            <img
              style={{ width: "1rem", height: "1rem", float: "left" }}
              src={NewTag}
              alt=""
            />
            <p>{data?.name}</p>
          </div>
          : data?.name
        }
      </div>
    </div>
  );
};

export default CarouselList;
